import {Component, Input} from '@angular/core';

export enum AnnotationBoxType {
  Standard = 'standard',
  Error = 'error'
}

@Component({
  selector: 'li3-form-annotation-box',
  templateUrl: './form-annotation-box.component.html',
  styleUrls: ['./form-annotation-box.component.scss']
})
export class FormAnnotationBoxComponent {
  @Input() type: AnnotationBoxType;

  annotationBoxTypes = AnnotationBoxType;

  constructor() {
  }
}
